import { useState } from 'react';
import Modal from './Modal';
import './AnalyticsConsentModal.css';

const FEATURES = [
  {
    icon: '🔒',
    text: 'Keine personenbezogenen Daten wie Name oder E-Mail'
  },
  {
    icon: '📊',
    text: 'Auswertung über Umami – privacy-freundliche Analytics'
  },
  {
    icon: '⚙️',
    text: 'Jederzeit änderbar unter Einstellungen → Datenschutz'
  }
];

export default function AnalyticsConsentModal({ isOpen, onAccept, onDecline }) {
  const [loading, setLoading] = useState(false);

  const handleChoice = async (consent) => {
    setLoading(true);
    try {
      if (consent) await onAccept();
      else await onDecline();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      type="info"
      contentClassName="modal-content--analytics-consent"
      onClose={() => {}}
      actions={
        <div className="analytics-consent-actions">
          <button
            type="button"
            className="modal-button modal-button-secondary analytics-consent-btn"
            disabled={loading}
            onClick={() => handleChoice(false)}
          >
            Nein, danke
          </button>
          <button
            type="button"
            className="modal-button modal-button-primary analytics-consent-btn"
            disabled={loading}
            onClick={() => handleChoice(true)}
          >
            {loading ? '⏳ Speichern...' : 'Ja, erlauben'}
          </button>
        </div>
      }
    >
      <div className="analytics-consent-modal">
        <div className="analytics-consent-badge" aria-hidden="true">
          <span className="analytics-consent-badge-icon">📈</span>
        </div>

        <h2 className="analytics-consent-title">Anonyme Nutzungsanalyse</h2>

        <p className="analytics-consent-question">
          Dürfen wir anonyme Analysedaten erheben, um die App zu verbessern?
        </p>

        <ul className="analytics-consent-features" aria-label="Details zur Nutzungsanalyse">
          {FEATURES.map((feature) => (
            <li key={feature.text} className="analytics-consent-feature">
              <span className="analytics-consent-feature-icon" aria-hidden="true">
                {feature.icon}
              </span>
              <span className="analytics-consent-feature-text">{feature.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
